import permissions from '../permissions'

const TRAINING_JOURNEY_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.TRAINNING_JOURNEYS.MANAGE,
  },
]

export default TRAINING_JOURNEY_LIST
